import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Button, Typography } from "@material-ui/core";
import styles from "./styles";
import Correct from "../../images/Correct.svg";

import "animate.css/animate.css";

const ThirdScreen = (props) => {
  const { classes, nextQuestion, questionAnswer } = props;

  return (
    <Grid container alignItems="center" direction="column">
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{flexDirection: "column", justifyContent: "center", padding: "0px 3%" }}
      >
          <Grid className={classes.imgContainer}>
            <img
              alt=""
              src={questionAnswer.thirdScreenImage}
              className={classes.correctIncorrectIcon}
            />
            <Grid style={{ paddingLeft: 15 }}>
              <Typography className={classes.title}>
                REAL WORLD WARNING:
              </Typography>
              <Typography className={classes.title}>
                {questionAnswer.thirdScreenTitle}
              </Typography>
            </Grid>
          </Grid>
          <Grid className={classes.desContainer}>
            <Typography
              className={classes.evalDesc}
              style={{ padding: "5px 0px" }}
            >
            {questionAnswer.thirdScreenText1}
            </Typography>
            {/* <Typography
              className={classes.evalDesc}
              style={{ padding: "5px 0px" }}
            >
            {questionAnswer.thirdScreenText2}
            </Typography>
            {questionAnswer.thirdScreenText3 &&
            <Typography
              className={classes.evalDesc}
              style={{ padding: "5px 0px" }}
            >
            {questionAnswer.thirdScreenText3}
            </Typography>} */}
          </Grid>
          <Button
            className={classes.nextButton}
            onClick={() => nextQuestion()}
          >
            NEXT
          </Button>

      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(ThirdScreen);
